module.exports = __webpack_public_path__ + "img/custom-group-no-records.4e8e53b6.webp";